export function hasValidWebsite(url: string | null | undefined): boolean {
  const u = url?.trim();
  return !!(
    u &&
    u !== "#" &&
    u !== "" &&
    (u.startsWith("http") || u.includes("."))
  );
}

export function websiteHref(url: string | null | undefined): string {
  const u = url?.trim();
  if (!u || u === "#") return "#";
  return u.startsWith("http") ? u : `https://${u}`;
}
